import React from 'react';

import { GlobalFeedbackCollector } from '@confluence/global-feedback-collector';

import type { ContentFeedbackService } from './services/content-types-feedback-service';
import { useGlobalFeedbackCollector } from './hooks/useGlobalFeedbackCollector';

export type GlobalFeedbackCollectorModalProps = {
	feedbackService: ContentFeedbackService;
};

export const GlobalFeedbackCollectorModal = ({
	feedbackService,
}: GlobalFeedbackCollectorModalProps) => {
	const modalState = useGlobalFeedbackCollector(feedbackService);

	if (!modalState.isModalOpen) {
		return null;
	}

	return (
		<GlobalFeedbackCollector {...modalState.modalProps} onClose={() => modalState.closeModal()} />
	);
};
